import { create } from "zustand";
import {
  ActionedTypeDefault,
  DefaultPageState,
} from "../../../common/models/StoreDefaultModel";
import { ActionsKey } from "../../../common/models/Actions";

type PointingType = {
  list: Array<any>;
  totalItems: number;
  pageState: any;
  actioned: ActionedType | null;
  setList: (cont: any) => void;
  resetList: () => void;
  setPageState: (cont: any) => void;
  setActioned: (act: ActionedTypeDefault | null) => void;

  resetPageState: () => void;
};

export type ActionedType = {
  data: any;
  action: ActionsKey;
};

const initialPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  // pagination: true,
};

/**
 * Landing
 */

/**
 * Container
 */
export const usePointingContainerStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  pageState: initialPageState,
  actioned: null,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),

  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));

/**
 * Bag
 */
export const usePointingBagStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  actioned: null,
  pageState: initialPageState,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
}));

/**
 * Vehicle
 */
export const usePointingVehicleStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  actioned: null,
  pageState: initialPageState,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
}));

/**
 * Craft
 */
export const usePointingCraftStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  actioned: null,
  pageState: initialPageState,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
}));

/**
 * Other
 */
export const usePointingOtherStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  actioned: null,
  pageState: initialPageState,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
}));

/**
 * End Landing
 */

/**
 * Boarding
 */

/**
 * Container
 */
export const usePointingBoardingContainerStore = create<PointingType>(
  (set) => ({
    list: [],
    totalItems: 0,
    actioned: null,
    pageState: initialPageState,
    setList: (data) =>
      set(() => ({
        list: data?.member,
        totalItems: data?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
    resetList: () =>
      set(() => ({
        list: [],
      })),

    setPageState: (data) => set(() => ({ pageState: data })),
    resetPageState: () => set(() => ({ pageState: initialPageState })),
  })
);

/**
 * Bag
 */
export const usePointingBoardingBagStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  actioned: null,
  pageState: initialPageState,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
}));

/**
 * Vehicle
 */
export const usePointingBoardingVehicleStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  actioned: null,
  pageState: initialPageState,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
}));

/**
 * Craft
 */
export const usePointingBoardingCraftStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  actioned: null,
  pageState: initialPageState,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
}));

/**
 * Other
 */
export const usePointingBoardingOtherStore = create<PointingType>((set) => ({
  list: [],
  totalItems: 0,
  actioned: null,
  pageState: initialPageState,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  resetList: () =>
    set(() => ({
      list: [],
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
}));

/**
 * End Boarding
 */
